export default __webpack_public_path__ + "maps-overview-circle-layer-1200-56559070d89dc3c3102533f302a2bdc7.png";